<template>
  <div>
    <input
        ref="fileProfile"
        type="file"
        class="file-profile"
        accept="image/png, image/jpeg, image/jpg"
        @change="onSelectFile">
    <v-btn
        class="mr-4"
        color="primary"
        width="100%"
        height="40"
        outlined
        @click="changeProfile()">
        <i class="far fa-file-upload pr-2"></i>
        {{ $vuetify.lang.t('$vuetify.visitorForm.uploadIdCard') }}
    </v-btn>
    <label class="text-upload-card">
        {{ $vuetify.lang.t('$vuetify.visitorForm.pngMaxSizeMb') }}
    </label>
  </div>
</template>

<script>
export default {
    name: 'UploadCardImage',

    methods: {
        changeProfile () {
            this.$refs.fileProfile.click()
        },

        onSelectFile (files) {
            this.$emit('change-profile-img', files)
        },

        clearProfile () {
            this.$refs.fileProfile.value = null
        }
    }

}
</script>

<style lang="scss" scoped>
.file-profile {
    display: none;
}
.text-upload-card {
    font-size: 12px;
    color: #6c6c6c;
    .color-rad {
        color: #ff544a;
    }
}
i {
    font-size: 18px;
}
</style>
